import { Component, OnInit, ViewChild,ElementRef } from '@angular/core';
import { AppService } from '../../../app.service';
import { GETSetupEquipmentService } from '../setup-equipment/setup-equipment.service';
import { CustomerSelectItem, EquipmentSelectItem } from '../setup-equipment/setup-equipment.model';
import { FormCatListVMSafety, GenericIdName } from '../setup-implement/setup-implement.model';
import { JobsiteSelectionFilter, ModelSelectionFilter, FilteredDigitalFormsVM, PerformSearchDigitalForm, DigtalFormSeachResult, FlagTypesVM, FamilyList, BulkDeleteUploadForm, DigitalFormData } from '../favourite-dialog/favourite-dialog-modal';
import { FavouriteDialogService } from '../favourite-dialog/favourite-dialog.service';
import { ActivatedRoute, Router } from '@angular/router';
import { DigitalFormService } from '../digital-form-fill/digital-form.service';
import { CopyDigitaFormComponent } from '../digital-form-fill/component/copy-digital-form/copy-digital-form.component';
import { SelectEquipmentComponent } from '../digital-form-fill/component/select-equipment/select-equipment.component';
import { OrdinalDateAdapter, ORD_DATE_FORMATS } from '../adapters/ordinal-date-adapter';
import { UserService } from '../../../../app/shared/services/user.service';
import { DeleteConfirmDigilatFormDialogComponent } from '../digital-form-fill/component/delete-confirm-dialog/delete-confirm-dialog.component';
import { NotificationsService } from 'angular2-notifications';
import { FavouriteDialogDigitalFormComponent } from './favourite-dialog-digital-form/favourite-dialog-digital-form.component';
import { DashboardFavourites } from '../dashboard/dashboard.model';
import { GETDashboardService } from '../dashboard/dashboard.service';
import { DigitalFormUserAlertComponent } from './digital-form-user-alert/digital-form-user-alert.component';
import { PreferencesService } from '../../preferences/preferences.service';
import {SelectionModel} from '@angular/cdk/collections';
import { DeleteConfirmCheckboxDialogComponent } from '../digital-form-fill/component/delete-confirm-checkbox-dialog/delete-confirm-checkbox-dialog.component';
import { DateAdapter, MAT_DATE_FORMATS } from '@angular/material/core';
import { MatDialog } from '@angular/material/dialog';
import { MatSort, Sort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { MatChipInputEvent } from '@angular/material/chips';
import { MatAutocompleteSelectedEvent } from '@angular/material/autocomplete';
import { COMMA, ENTER } from '@angular/cdk/keycodes';
import { PageEvent } from '@angular/material/paginator';
import { CryptoService } from '../../../services/crypto.service';
import { DashBoardModule } from '../../../../app/shared/enums/allEnums';
interface Jobsite {

  Id: number;
  Name: string;
}




@Component({
  selector: 'app-digital-form-search',
  templateUrl: './digital-form-search.component.html',
  styleUrls: ['./digital-form-search.component.scss'],
  providers: [
    {
      provide: DateAdapter, useClass: OrdinalDateAdapter
    },
    {
      provide: MAT_DATE_FORMATS, useValue: ORD_DATE_FORMATS
    }
  ]

})

export class DigitalFormSearchComponent implements OnInit {
  //@ViewChild(MatSort) sort!: MatSort;
  //dataSource = new MatTableDataSource();
  dataSource: any;
  //appUris: AppUris;
  //Job role
  separatorKeysCodes: number[] = [ENTER, COMMA];
  isJobRoleDefault: boolean = true;
  isAdmin: boolean = false;
  isSupervisour: boolean = false;
  isInspector: boolean = false;
  
  _currentSort: Sort = { active: 'FormName', direction: 'desc' };
  // Drop-down lists
  customerList: CustomerSelectItem[] = [];
  filteredCustomers: any[] = [...this.customerList];
  selectedCustomer: number[] = [];
  selectedCustomers:any = [];
  pageSize = 50;
  pageIndex :number=0;
  pageSizeOptions: number[] = [20,50,100];
  recordCount: number = 100;
  recordCount1: number = 100;
  @ViewChild('chipInput') chipInput: ElementRef<HTMLInputElement>;
  showBar:boolean=false;

  // Filter customers based on input
  filterCustomers(value: string): void {
    const filterValue = value.toLowerCase();
    this.filteredCustomers = this.customerList.filter(customer =>
      customer.Name.toLowerCase().includes(filterValue) &&
      !this.selectedCustomers.some(c => c.Name === customer.Name)
    );
  }

  // Select customer from autocomplete
  selectCustomer(event: any): void {
    const customerName = event.option.value;
    const selectedCustomer = this.customerList.find(c => c.Name === customerName)

    if (selectedCustomer && !this.selectedCustomers.some(c => c.Name === selectedCustomer.Name)) {
      this.selectedCustomers.push(selectedCustomer);
       this.selectedCustomer.push(selectedCustomer.Id);
    }

    // Clear input
         this.filterCustomers('');
     this.loadFamiliesForCustomer();
    this.loadJobsitesForCustomer();
    this.chipInput.nativeElement.value = '';
    this.filterCustomers('');
  }

  // Remove a customer chip
  removeChip(chip: any): void {
    const index = this.selectedCustomers.indexOf(chip);
    if (index >= 0) {
      this.selectedCustomers.splice(index, 1);
      this.selectedCustomer.splice(index, 1);
    }
    this.loadAllFamilyList();
   this.loadJobsitesForCustomer();
    this.filterCustomers('');
  }

  sortChanged(sort: Sort) {
    if (this._currentSort.active != sort.active)
      //this.loadingPage = 1;
    this._currentSort = sort;
    //this.retrieveEquipmentsBySearchItems(this.loadingPage, this.loadSize);
  }
  // @ViewChild('chipInput') chipInput: any;
  // onSelectCustomer(event: any) {

  //   let Id = this.customerList.find(f => f.Name == event.value).Id;

  //   this.selectedCustomers.push(event.value);
  //   this.selectedCustomer.push(Id);
  //   this.filterCustomers('');
  //   this.loadFamiliesForCustomer();
  //   this.loadJobsitesForCustomer();
  //   // event.target.value = '';
  //   this.chipInput.nativeElement.value = '';


  // }


//  jobsiteList: GenericIdName[] = [];
  equipmentList: any = [];

  familyList: FamilyList[] = [];
  selectedFamily: number[] = [];
  selectedFamilies: any[] = [];
  @ViewChild('familychipInput') familychipInput: ElementRef<HTMLInputElement>;

  // Add a family to the chip list
  addFamily(event: MatChipInputEvent): void {
    const value = (event.value || '').trim();

    // Add the family name if valid and not already selected
    const foundFamily = this.familyList.find(family => family.Name.toLowerCase() === value.toLowerCase());
    if (foundFamily && !this.selectedFamilies.includes(foundFamily.Name)) {
      this.selectedFamilies.push(foundFamily.Name); // Store the Name for display
    }

    // Clear the input value
    event.chipInput!.clear();
    this.filterFamilies('');
  }

  // Remove a family from the chip list
  removeFamily(familyName: string): void {
    const index = this.selectedFamilies.indexOf(familyName);
    if (index >= 0) {
      this.selectedFamilies.splice(index, 1);
      this.selectedFamily.splice(index, 1);
      this.filterFamilies('');
    }
  }

  // Select a family from autocomplete
  selectFamily(event: any): void {
    const familyName = event.option.value;
    const selectedFamily = this.familyList.find(f => f.Name === familyName);

    if (selectedFamily && !this.selectedFamilies.some(f => f.Name === selectedFamily.Name)) {
      this.selectedFamilies.push(selectedFamily); 
      this.selectedFamily.push(selectedFamily.Id);
    }

    // Clear input
   
    this.loadModelList();
    
    this.familychipInput.nativeElement.value = '';
    this.filterFamilies('');
  }

  // Filter families based on user input
  filterFamilies(value: string): void {
    const filterValue = value.toLowerCase();

    this.filteredFamilies = this.familyList.filter(family =>
      family.Name.toLowerCase().includes(filterValue) && !this.selectedFamilies.includes(family.Name)
    );

    // Reset filtered families if input is empty
    if (value === '') {
      this.filteredFamilies = [...this.familyList];
    }
  }
  modelList:any = [];
  filteredModelList: { Id: number; Name: string }[] = [];
selectedModels: { Id: number; Name: string }[] = [];
@ViewChild('modelInput') modelInput: ElementRef<HTMLInputElement>;

addModel(event: any): void {
  const value = (event.value || '').trim();

  const foundModel = this.modelList.find(
    (m) => m.Name.toLowerCase() === value.toLowerCase()
  );

  if (foundModel && !this.selectedModels.some(m => m.Id === foundModel.Id)) {
    this.selectedModels.push(foundModel);
  }

  event.chipInput!.clear();
  this.filterModels('');
}

// Select model from autocomplete
selectModel(event: any): void {
  const selectedModel = event.option.value;

  if (!this.selectedModels.some(m => m.Id === selectedModel.Id)) {
    this.selectedModels.push(selectedModel);
  }

  this.modelInput.nativeElement.value = '';
  this.filterModels('');
}

// Remove model chip
removeModel(model: { Id: number; Name: string }): void {
  const index = this.selectedModels.findIndex(m => m.Id === model.Id);
  if (index >= 0) {
    this.selectedModels.splice(index, 1);
  }

  this.filterModels('');
}

// Filter models for autocomplete
filterModels(value: string): void {
  const filterValue = value.toLowerCase();

  this.filteredModelList = this.modelList.filter(
    (model) =>
      model.Name.toLowerCase().includes(filterValue) &&
      !this.selectedModels.some(m => m.Id === model.Id)
  );
}

  ShowHidefield(){
    this.showBar=!this.showBar
  }

  formCatList: FormCatListVMSafety[] = [];
  formList: any = [];
  inspectorList: any = [];
  flagTypesList: FlagTypesVM[] = [];
  dateRangetypes:GenericIdName[]=[];

  // Search Filters
 // selectedCustomer: number[] = [];
 
  selectedJobsite: number[] = [];
   jobsiteList: any = [];
  filteredJobsites: any[] = [];
selectedJobsites: any[] = [];
@ViewChild('jobsiteInput') jobsiteInput: ElementRef<HTMLInputElement>;

filterJobsites(value: string): void {
  const filterValue = value.toLowerCase();
  console.log("Filtering job sites with value:", value);

  this.filteredJobsites = this.jobsiteList.filter(jobsite =>
    jobsite.Name.toLowerCase().includes(filterValue)

  );
  console.log("Filtered job sites:", this.filteredJobsites);
}
addJobsite(event: MatChipInputEvent): void {
  const input = event.input;
  const value = event.value.trim();

  // Validate the input before adding
  const isJobsiteValid = this.selectedJobsites.some(jobsite => jobsite.Name === value);

  if (value && isJobsiteValid && !this.selectedJobsites.some(jobsite => jobsite.Name === value)) {
    // Add the valid jobsite
    const newJobsite = this.selectedJobsites.find(jobsite => jobsite.Name === value);
    this.selectedJobsites.push(newJobsite);
    console.log("Added jobsite:", newJobsite);
  } else if (!isJobsiteValid) {
    console.warn("Invalid jobsite:", value);
  }

  // Clear the input field
  if (input) {
    input.value = '';
  }

  this.filterJobsites(''); // Reset the filter
}
removeJobsite(jobsite: Jobsite): void {
  // Find the index of the jobsite in the selectedJobsites array by comparing IDs
  const index = this.selectedJobsites.findIndex(js => js.Id === jobsite.Id);

  if (index >= 0) {
    // Remove the jobsite from selectedJobsites
    this.selectedJobsites.splice(index, 1);

    // Remove the jobsite's ID from selectedJobsite
    const idIndex = this.selectedJobsite.indexOf(jobsite.Id);
    if (idIndex >= 0) {
      this.selectedJobsite.splice(idIndex, 1);
    }
  }
}

selectJobsite(event: MatAutocompleteSelectedEvent): void {
  const selectedJobsite = event.option.value;
  
  if (this.selectedJobsites.findIndex(js => js.Id === selectedJobsite.Id) === -1) {
    
    const Id = event.option.value.Id;
    this.selectedJobsite.push(Id)
    this.selectedJobsites.push({Id: selectedJobsite.Id, Name: selectedJobsite.Name})
  }
  this.jobsiteInput.nativeElement.value = '';
  
  this.loadEquipmentForJobsite()
  console.log("Selected Jobsites after selection:", this.selectedJobsites);
}







  selectedEquipment: any[] = [];
  filteredEquipment: any = [...this.equipmentList];

  /** Filters the available equipment based on user input */
  filterEquipment(value: string): void {
    const filterValue = value.toLowerCase();
    this.filteredEquipment = this.equipmentList.filter(
      equipment =>
        equipment.UnitNumber.toLowerCase().includes(filterValue) ||
        equipment.SerialNumber.toLowerCase().includes(filterValue)
    );
    console.log('Filtered Equipment:', this.filteredEquipment);
  }

  selectEquipment(event: MatAutocompleteSelectedEvent): void {
    const selectedEquipment: EquipmentSelectItem = event.option.value;
    if (!this.selectedEquipment) {
      this.selectedEquipment = []; // Initialize if null or undefined
    }
    if (selectedEquipment && selectedEquipment.Id) {
      if(this.selectedEquipment!=null){
        if (!this.selectedEquipment.some(e => e.Id === selectedEquipment.Id)) {
          this.selectedEquipment.push(selectedEquipment);
          console.log('Updated selectedEquipment:', this.selectedEquipment);
        }
      }else{
        this.selectedEquipment.push(selectedEquipment.SerialNumber);
      }
    
    } else {
      console.error('Invalid Equipment:', selectedEquipment);
    }

    this.filterEquipment('');
  }

  removeEquipment(equipment: EquipmentSelectItem): void {
    const index = this.selectedEquipment.indexOf(equipment);

    if (index >= 0) {
      this.selectedEquipment.splice(index, 1);
      console.log('Removed Equipment:', equipment);
    }
  }
  

  /** Adds an equipment from the input field (optional feature) */
  addEquipment(event: MatChipInputEvent): void {
    const inputValue = event.value?.trim();
    if (inputValue) {
      // Ensure you are adding only valid equipment
      const matchedEquipment = this.equipmentList.find(equipment =>
        equipment.UnitNumber.toLowerCase() === inputValue.toLowerCase() ||
        equipment.SerialNumber.toLowerCase() === inputValue.toLowerCase()
      );
  
      if (matchedEquipment && !this.selectedEquipment.includes(matchedEquipment)) {
        this.selectedEquipment.push(matchedEquipment);
      }
    }
  
    event.input.value = '';
    this.filterEquipment('');
  }
  
  //selectedFamily: number[] = [];
  selectedModel: number[] = [];
  selectedCategory: number[] = [];
  selectedForm:any[]=[];

  selectedCategories: FormCatListVMSafety[] = [];
  filteredCategories: any[] = [];
  addCategory(event: any): void {
    const value = (event.value || '').trim();
    const foundCategory = this.formCatList.find((cat) => cat.Name.toLowerCase() === value.toLowerCase());

    if (foundCategory && !this.selectedCategories.includes(foundCategory)) {
      this.selectedCategories.push(foundCategory);
    }
    event.chipInput!.clear();
    this.filterCategories('');
  }
  removeCategory(category: any): void {
    const index = this.selectedCategories.indexOf(category);
    if (index >= 0) {
      this.selectedCategory.splice(index, 1);
      this.selectedCategories.splice(index, 1);
    }
    this.filterCategories('');
  }

  selectCategory(event: any): void {
    const Id = event.option.value.Id;
    this.selectedCategory.push(Id)
    const selectedCategory = event.option.value ;
    if (selectedCategory && !this.selectedCategories.includes(selectedCategory)) {
      this.selectedCategories.push(selectedCategory);
    }
    this.filterCategories('');
    this.LoadForms();
  }

  // Filter categories
  filterCategories(value: string): void {
    const filterValue = value.toLowerCase();
    this.filteredCategories = this.formCatList.filter(
      (cat) => cat.Name.toLowerCase().includes(filterValue) && !this.selectedCategories.includes(cat)
    );
    if (!value) {
      this.filteredCategories = this.formCatList;
    }
    console.log('this.filteredCategories',this.filteredCategories);
  }
  //selectedForms: number[] = [];
  //filteredForms: GenericIdName[] = [];
  selectedForms: any[] = [];
  filteredForms: any[] = [];
  filterForms(value: string): void {
    const filterValue = value.toLowerCase();
    this.filteredForms= this.formList.filter(
      (form) => form.Name.toLowerCase().includes(filterValue) && !this.selectedCategories.includes(form)
    );
    if (!value) {
      this.filteredCategories = this.formList;
    }
    console.log('this.filteredForms',this.filteredForms);
  }
  addForm(event: any): void {
    const value = (event.value || '').trim();
    const foundForm = this.formList.find((form) => form.Name.toLowerCase() === value.toLowerCase());

    if (foundForm && !this.selectedForms.includes(foundForm)) {
      this.selectedForms.push(foundForm);
    }
    event.chipInput!.clear();
    this.filterForms('');
  }
  removeForm(form: any): void {
    const index = this.selectedForms.indexOf(form);
    if (index >= 0) {
     this.selectedForm.splice(index, 1);
      this.selectedForms.splice(index, 1);
    }
    this.filterForms('');
  }
  selectForm(event: any): void {
      const Id = event.option.value.Id;
      this.selectedForm.push(Id)
      const selectedForm = event.option.value ;
      if (selectedForm && !this.selectedForms.includes(selectedForm)) {
        this.selectedForms.push(selectedForm);
      }
      this.filterForms('');
    }


  
  selectedInspectors: any[] = [];
  
  filteredInspectors: { Id: number; Name: string }[] = [];
  addInspector(event: any): void {
    const value = (event.value || '').trim();
    const foundInspector = this.inspectorList.find((ins) => ins.Name.toLowerCase() === value.toLowerCase());

    if (foundInspector && !this.selectedInspectors.includes(foundInspector)) {
      this.selectedInspectors.push(foundInspector);
    }

    event.chipInput!.clear();
    this.filterInspectors('');
  }

  // Remove inspector
  removeInspector(inspector: { Id: number; Name: string }): void {
    const index = this.selectedInspectors.indexOf(inspector);

    if (index >= 0) {
      this.selectedInspectors.splice(index, 1);
    }

    this.filterInspectors('');
  }

  // Select family from autocomplete
  // @ViewChild('familyInput') familyInput: ElementRef<HTMLInputElement>;
  
  // selectFamily(event: any): void {
   

  
    
  //   let Id = this.familyList.find(f => f.Name == event.value).Id;
  //   this.selectedFamily.push(Id);
  //   const selectedFamily = event.value;

  //   if (selectedFamily && !this.selectedFamilies.includes(selectedFamily)) {
  //     this.selectedFamilies.push(selectedFamily);
  //   }
  //   this.familyInput.nativeElement.value = '';
  //   this.filterFamilies('');
  // }
  selectInspector(event: any): void {
    const selectedInspector = event.option.value;
    //console.log("selectedInspector,", selectedInspector);
    if (!this.selectedInspectors.includes(selectedInspector)) {
      this.selectedInspectors.push(selectedInspector);
    }

    this.filterInspectors('');

  }

  // Filter inspectors for autocomplete
  filterInspectors(value: string): void {
    const filterValue = value.toLowerCase();
    this.filteredInspectors = this.inspectorList.filter(
      (inspector) =>
        inspector.Name.toLowerCase().includes(filterValue) &&
        !this.selectedInspectors.includes(inspector)
    );
  }
  selectedStatus: number[] = [];
  startDate: Date;
  endDate: Date;

  selectedDateRange:number;

  //Aviailable Forms
  AvailbleFilteredDigitalForms: FilteredDigitalFormsVM[] = [];
  FilledFilteredDigitalForms: FilteredDigitalFormsVM[] = [];
  PerformResult: DigtalFormSeachResult;
  PerformAvailableResult: DigtalFormSeachResult;
  resultData:DigitalFormData;
  completedFormData:DigitalFormData;
  identityServerUri: string;
  inProgress: boolean = false;
  inReview: boolean = false;
  inCompleted: boolean = false;
  NotCompleted: boolean = false;

  AttentionRequired: boolean = true;
  ImmediateAction: boolean = true;
  MultipleAnswers: boolean = true;
  CommentAdded: boolean = true;
  AllFlags: boolean = true;

  
  //@ViewChild(MatSort) sort: MatSort;
  displayedColumns = [];

  Customer = true
  Jobsite = true
  SerialNo = true
  UnitNo = true
  Family = false
  Model = true
  SMRDiff = false
  selection = new SelectionModel(true, []);

  userFavorites: DashboardFavourites[] = [];
  selectedUserFavourites: DashboardFavourites[] = [];
  sortedData: FilteredDigitalFormsVM[];
  userFavoritesDefault: DashboardFavourites;
  sortName: string ='InspectionDate';
  sortOrder: string = 'desc';
  fromData: FilteredDigitalFormsVM[];
       EnableDashboardAlerts:boolean=false
  constructor(
    private _appService: AppService, private _equipmentService: GETSetupEquipmentService,
    public _favouriteDialogService: FavouriteDialogService,private _user:UserService,
    public _formService: DigitalFormService,public _notify:NotificationsService,
    private _router: Router, private _dialog: MatDialog,  
    private readonly _pref: PreferencesService, private _crypto: CryptoService
  ) { 
    
  }
    
  ngOnInit() {
    this._appService.setPageTitle('Search Digital Forms');
   // this._appService.setPageSubTitle('');
    //this.dataSource.sort = this.sort;
    this.displayedColumns = ['FormId','FormName', 'CatName', 'EqCustomer', 'EQJobsite', 'Serial', 'Unit', 'Model', 'CreateDate_', 'SMR' , 'Inspector', 'Status', 'flag', 'delete', 'description'];
    
     this._pref.GetDashBoardAlertEnableStatus().subscribe(res=>{
            if(res=="True"){
                this.EnableDashboardAlerts=true;
            }else{
                this.EnableDashboardAlerts=false;
            }
        });
    this.LoadJobRoles();
    this.loadFormCatList();
    
    // this.submitSelection();
    this.loadCustomers();
    this.loadAllFamilyList();
    this.loadFlagtypes();
    this.LoadInspectors();
    this.LoadDateRangeTypes();
    this.inReview = false;
    this.inCompleted = true;
    this.inProgress = true;
    this.NotCompleted = false;
    this._appService.getApplicationConfigValue("IdentityServerUri").subscribe(result => {
      this.identityServerUri = result;

    });

    this.startDate = this.defaultSearchStartDate;
    this.endDate = this.defaultSearchEndDate;
    this.Family = false;

    this.loadFavourites();
    this.getUserAlertsforDashbpard()

    //this._appService.getAppUris().subscribe(result => { this.appUris = result; });

  }


  /**
   * Returns the default start date to be used in the shared
   * search component initially. This date is 3 months before
   * the current date.
   * @returns A date object.
   */
  get defaultSearchStartDate(): Date {
    const date = new Date(Date.now());
    date.setDate(date.getDate() - 90);
    return date;
  }

  /**
   * Returns the default end date to be used in the shared
   * search component initially. This date is 1 day ahead of the
   * current date.
   * @returns A date object.
   */
  get defaultSearchEndDate(): Date {
    const date = new Date();
    date.setDate(date.getDate() + 1);
    return date;
  }

 

  countdays:number=0;

  LoadUserDefaultFormCatId (){
    this._user.getUserDefaultDigitlFormCategory().subscribe(res=>{
      if(res>0){
        let Catarray = [];
            Catarray.push(res);
            this.selectedCategory = Catarray;
            console.log("onload__ ", this.selectedCategory,this.formCatList)
        if (this.selectedCategory.length > 0) {
              if(this.formCatList.length>0){
                this.countdays = this.formCatList.find(x => x.Id == this.selectedCategory[0]).Days;
                this.selectedCategories = this.formCatList.filter(x => x.Id === this.selectedCategory[0]);
              }
              //this.startDate = new Date(new Date().setDate(new Date().getDate() - this.countdays));
            }
            this.LoadForms();
      }
    })
  }
  LoadJobRoles() {
    this._user.getUserJobRoles().subscribe(roles => {
      roles.forEach(r => {
        switch (r.Name) {
          case 'Inspectors':
            this.isJobRoleDefault = false;
            this.isInspector = true;
            break;
          case 'Interpreters':
            this.isJobRoleDefault = false;
            break;
          case 'Super User':
            this.isJobRoleDefault = false;
            break;
          case 'Administrator':
            this.isJobRoleDefault = false;
            this.isAdmin = true;
            break;
            case 'Customer Admin':
              this.isJobRoleDefault = false;
            this.isAdmin = true;
              break;
          case 'Supervisor':
            this.isJobRoleDefault = false;
            this.isSupervisour = true;
            break;
        }
      });
      console.log("isSupervisour_________________",this.isSupervisour)
    })


  }

  loadAllFamilyList(){
    this._favouriteDialogService.getllFamilyList().subscribe(res=>{
      this.familyList =res;
    })
  }


  loadCustomers() {
    this.familyList  = this. _favouriteDialogService.availableFamilyList 
    this._equipmentService.getCustomerList().subscribe(r => {
      this.customerList = r;
      if (this.customerList.length == 1) {
        let onlyonecus = this.customerList[0].Id;
        let arrycus = [];
        arrycus.push(onlyonecus);
        this.selectedCustomer = arrycus;
        if (this.selectedCustomer.length > 0) {
          this.loadJobsitesForCustomer();
        }
      }
    });
  }

  loadFlagtypes() {
    this._favouriteDialogService.GetFlagTypesAvailable().subscribe(res => {
      this.flagTypesList = res;
    })
  }
  // Show the list of Jobsites for the selected customer.
  // Also loads the observation lists.
  loadJobsitesForCustomer() {
    if (this.selectedCustomer == null)
      return;
    this.selectedJobsite = [];
    this.jobsiteList = [];
    this.selectedEquipment = null;
    this.equipmentList = [];
    var params: JobsiteSelectionFilter = {
      Customers: this.selectedCustomer,
    }
  this._favouriteDialogService.GetjobsitesAvailable(params).subscribe(r => {
      if (r) {
          this.jobsiteList = r;
          this.filteredJobsites = r;
      }
    });
    
  }

  filteredFamilies:GenericIdName[]=[];
  loadFamiliesForCustomer(){
    var params: JobsiteSelectionFilter = {
      Customers: this.selectedCustomer,
    }
    if(this.selectedCustomer.length>0){
      this._favouriteDialogService.GetFamiliesForSelectedCustomers(params).subscribe(r => {
        if (r) {
          this.filteredFamilies = r;
          if (this.filteredFamilies.length>0) {
          
            this.familyList = this.filteredFamilies;//this.familyList.filter(x=>)
          }
        }
      });
    }else{
      this.loadAllFamilyList();
    }
    
  }

  // Show the list of equipment for the selected jobsite.
  
  loadEquipmentForJobsite() {
    if (this.selectedJobsite == null)
      return;
    var params: number[] = this.selectedJobsite;
    this._favouriteDialogService.GetEquipmentAvailable(params).subscribe(r => {
      if (r) {
        this.equipmentList = r;
        this.filteredEquipment=r;
      }
    });
  }

  LoadInspectors() {
    this._favouriteDialogService.GetInspectorAvailable().subscribe(r => {
      if (r) {
        this.inspectorList = r;
      }
    });
  }

  LoadDateRangeTypes() {
    this._favouriteDialogService.GetCustomDateRangeTypes().subscribe(r => {
      if (r) {
        this.dateRangetypes = r;
      }
    });
  }
  loadModelList() {
    this.modelList = null
    var params: ModelSelectionFilter = {
      Families: this.selectedFamily,
      Makes: []
    }
    this._favouriteDialogService.GetModelsAvailable(params).subscribe(r => {
      if (r) {
        this.modelList = r;
        this.filteredModelList=r;
      }
      
    });

  }
  GetColor(flagId: number) {

    let flag = this.flagTypesList.find(x => x.ID == flagId);
    return flag.Color;

  }
  loadFormCatList() {
    this._favouriteDialogService.getFormCategoryListForSafety().subscribe(result => {
      this.formCatList = result.filter(category => category.Name && category.Name.trim() !== '');
      this.LoadUserDefaultFormCatId();
    })
  }

  

  LoadForms() {
    this._favouriteDialogService.GetFormListAvailable(this.selectedCategory).subscribe(res => {
      this.formList = res.filter(form=>form.Name&&form.Name.trim() !=='');

      if(this.selectedCategory.length>0){
        
        this.countdays = this.formCatList.find(x=>x.Id==this.selectedCategory[0]).Days;
        console.log("chnages_", this.countdays,this.formCatList)
        //this.startDate = new Date(new Date().setDate(new Date().getDate() - this.countdays));
      }else{
        this.startDate = this.defaultSearchStartDate;
        this.endDate=this.defaultSearchEndDate;
      }
    })
  }


  ResetFields() {
    this.selectedCustomer = [];
    this.selectedCustomers=[];
    this.selectedJobsite = [];
    this.selectedJobsites = [];
    this.selectedEquipment = [];
    
    this.selectedFamily = [];
    this.selectedFamilies = [];
    this.selectedModel = [];
    this.selectedModels = [];
    this.selectedCategory = [];
    this.selectedCategories = [];
    this.selectedForm = [];
    this.selectedForms = [];
    this.inReview = false;
    this.inCompleted = true;
    this.inProgress = true;
    this.NotCompleted = false;
    this.startDate = this.defaultSearchStartDate;
    this.endDate = this.defaultSearchEndDate;
    this.AttentionRequired = true;
    this.ImmediateAction = true;
    this.MultipleAnswers = true;
    this.CommentAdded = true;
    this.AllFlags = true;
    this.selectedInspectors = [];

    this.AvailbleFilteredDigitalForms = null;
    this.FilledFilteredDigitalForms = null;
    //this.submitSelection();
    this.selectedDateRange = null;
    this.dataSource = null;
    this.AvailbleFilteredDigitalForms = null;
    this.recordCount1 = 0;
    this.recordCount = 0;
  }
  loading: boolean = false;
  Availableloading: boolean = false;

  submitSelection() {
    // this.NotCompleted = false;
    // this.inProgress = true;
    // this.inReview = false;
    // this.inCompleted = true;

    console.log("statusList ", this.selectedStatus)
    if (this.selectedStatus != null && this.selectedStatus.length > 0) {
      this.selectedStatus.map(x => {
        if (x == 1)
          this.NotCompleted = true;
        else if (x == 2)
          this.inProgress = true;
        else if (x == 3)
          this.inReview = true;
        else
          this.inCompleted = true;
      })
    }
    this.loading = true;
    this.Availableloading = true;
    var params: PerformSearchDigitalForm = {
      customer: this.selectedCustomer,
      jobsite: this.selectedJobsite,
      equipment: this.selectedEquipment,
      family: this.selectedFamily,
      models: this.selectedModel,
      formCategory: this.selectedCategory,
      forms: this.selectedForm,
      Completed: this.inCompleted,
      InProgress: this.inProgress,
      InReview: this.inReview,
      NotCompleted: this.NotCompleted,
      AttentionRequired: this.AttentionRequired,
      ImmediateAction: this.ImmediateAction,
      MultipleAnswers: this.MultipleAnswers,
      CommentAdded: this.CommentAdded,
      AllFlags: this.AllFlags,
      inspector: this.selectedInspectors.map(i => i.Id),
      startDate: this.startDate,
      endDate: this.endDate,
      sortName: this.sortName,
      sortOrder: this.sortOrder,
      PageNo: this.pageIndex || 1,
      PageSize: this.pageSize || 10
      // SortName: this._currentSort.direction,
      // SortOrder : this._currentSort.active
    }

    this._favouriteDialogService.GetDigitalFormSearchResult(params).subscribe((res: any) => {
      //this.PerformResult = res;
      this.resultData= res;
      console.log("isInspector", this.isInspector)
      console.log("supervior", this.isSupervisour)
      const searchResult = res?.DigitalFormData && res.DigitalFormData.length > 0
      ? res.DigitalFormData[0]
      : null;
      console.log("result", this.resultData)
      //this.FilledFilteredDigitalForms = this.PerformResult.CompletedForms;
      console.log("FilledFilteredDigitalForms", this.FilledFilteredDigitalForms)
      //AES256
      searchResult.CompletedForms.forEach((insp: any) => {
        if (insp?.Inspector && insp.Inspector.length > 0) {
          insp.Inspector = this._crypto.decrypt(insp.Inspector);
        }
      });
      // this.dataSource.data = this.PerformResult.CompletedForms;
      this.dataSource = searchResult.CompletedForms;
      this.recordCount = this.resultData.TotalRecords;
      // console.log("dataSource", this.dataSource.data);
      console.log("dataSource1", this.dataSource);
      this.loading = false;
      console.log(this.PerformResult);
    });

    this._favouriteDialogService.GetDigitalAvailableFormSearchResult(params).subscribe((res: any) => {
      //this.PerformAvailableResult = res;
      this.completedFormData = res;
      console.log("availableFormResult", this.completedFormData)
      const searchResult1 = res?.DigitalFormData && res.DigitalFormData.length > 0
      ? res.DigitalFormData[0]
      : null;
      //this.AvailbleFilte1redDigitalForms = this.PerformAvailableResult.AvaibleFormsList;
      this.AvailbleFilteredDigitalForms = searchResult1.AvaibleFormsList;
      console.log("AvailbleFilteredDigitalForms", this.AvailbleFilteredDigitalForms);
      this.recordCount1 = this.completedFormData.TotalRecords;
      this.Availableloading = false;
      console.log(this.FilledFilteredDigitalForms)
    });
  }

    onUserPaginateChange(event: PageEvent) {
      console.log(event);
      this.pageIndex = event.pageIndex;
      this.pageSize = event.pageSize;
      this.submitSelection();
    }
    
    onSortChange(sort: Sort) {
      let sortName = sort.active;
      console.log("sortName:",sortName);
      this.sortName = sortName;
      this.sortOrder = sort.direction;
      this.pageIndex = 0;
      this.submitSelection();
    }

  redirectToEdit(formId: number) {
    // this._router.navigate([this.identityServerUri+'administration/edit-digitalForm']);
    //window.open(this.identityServerUri + 'administration/edit-digitalForm?form=' + formId);

    window.open('edit-digitalform/'+ formId,'_blank');  
    //= this.identityServerUri + 'administration/edit-digitalForm?form='+formId;
  }
  uploadId: number;
  FillNewForm(formId: number, IsStartBySupervisor: boolean) {
    let selectedform = this.AvailbleFilteredDigitalForms.find(x => x.FormId == formId);

    console.log("selectedform", selectedform)
    if (selectedform.ModelsList != "" && selectedform.ModelsList != null) {
      //this need to lnked to equipment

      this.OpenSelectLinkedEquipmentFormDialog(formId, selectedform.LinkedModels, selectedform.LinkedCustomer, selectedform.IsFECRForm, IsStartBySupervisor);

    } else {
      // this not linked to equipment
      this._favouriteDialogService.CreateUploadForm(formId, 0,"", "").subscribe(res => {
        console.log("res", res)
        this.uploadId = res;
        if (res > 0) {
         // this._router.navigate(['/digitalform/fill', formId, this.uploadId]);
         this._pref.GetReplaceExistingTabStatus().subscribe(res=>{
          if(res=="True"){
            this._router.navigate(['/digitalform/fill', formId, this.uploadId]);
          }else{             
            window.open('digitalform/fill/'+ formId+ '/'+ this.uploadId,'_blank');   
          }
      });
    
        }
      })
    }
  }

//TT-4276
OpenDeleteInspection(UploadId:number){
  const addSectionDialog = this._dialog.open(DeleteConfirmDigilatFormDialogComponent, {

  disableClose:true
  });
  addSectionDialog.afterClosed().subscribe(res => {
    if (res == true) {
      this.DeleteDigitalFormInspection(UploadId);
    }
  });
}

DeleteDigitalFormInspection(UploadID:number){
  this._favouriteDialogService.DeleteFormUploadDigitalForm(UploadID).subscribe(res=>{
    if(res==true){
      this._notify.success('Successfully Deleted')
    }else{
      this._notify.error("Error, Please Contact TrackTreads")
    }
 
  })
}
  OpenCopyFormDialog(formId: number) {
    const addSectionDialog = this._dialog.open(CopyDigitaFormComponent, {

      data: {
        formId: formId,
      }
    });
    addSectionDialog.afterClosed().subscribe(details => {
      if (details == false) {
        //this.GetDigitalFormDetails();
      }
    });
  }

  OpenSelectLinkedEquipmentFormDialog(formId: number, selectedModels: GenericIdName[], selectedCustomers: GenericIdName[], isFECR: boolean, isStartByInspector:boolean) {
    const addSectionDialog = this._dialog.open(SelectEquipmentComponent, {

      data: {
        formId: formId,
        linkedModels: selectedModels,
        linkedCustomers: selectedCustomers,
        isFECR: isFECR,
        isSupervisour: this.isSupervisour,
        isStartBySupervisor: isStartByInspector
      }
    });
    addSectionDialog.afterClosed().subscribe(details => {
      if (details == false) {
        //this.GetDigitalFormDetails();
      }
    });
  }

  EditFiledForm(formId: number, uploadId: number) {
    this._router.navigate(['/digitalform/fill', formId, uploadId]);
  }

  CreateNewForm() {
    //this._router.navigate([this.identityServerUri +'/administration/setup-digitalForm']);
  //  window.open(this.identityServerUri + 'administration/setup-digitalForm');
  this._pref.GetReplaceExistingTabStatus().subscribe(res=>{
    if(res=="True"){
      this._router.navigate([this.identityServerUri +'/administration/setup-digitalForm']);
    }else{             
      window.open(this.identityServerUri + 'administration/setup-digitalForm');
    }
});
  }

  changeCheckbox(value: boolean, key, index: number) {
    if (value === false) {
      this.removeArrayelement(this.displayedColumns, key)
    } else {
      this.displayedColumns.splice(index, 0, key)
    }
  }
  removeArrayelement(arr, key) {
    let a = arguments, L = a.length, ax;
    while (L > 1 && arr.length) {
      key = a[--L];
      while ((ax = arr.indexOf(key)) !== -1) {
        arr.splice(ax, 1);
      }
    }
    return arr;
  }


  navigatetoUploadForm(row) {
    console.log("Row clicked", row)
     //this._router.navigate(['/digitalform/fill', row.FormId, row.UploadId]);
   // window.open('/digitalform/fill/' + row.FormId + '/' + row.UploadId, '_blank');

   this._pref.GetReplaceExistingTabStatus().subscribe(res=>{
    if(res=="True"){
      this._router.navigate(['/digitalform/fill', row.FormId, row.UploadId ]);
    }else{             
      window.open('/digitalform/fill/' + row.FormId + '/' + row.UploadId, '_blank');
     
    }
});
  }

  getEvalClass(smrDif: number) {
    if (smrDif >= 0 && smrDif <= 24) {
      return " SmRColumn evalColorA";
    }
    else if ((smrDif > 24) && (smrDif <= 35)) {
      return " SmRColumn evalColorC";
    }
    else if (smrDif > 35) {
      return "SmRColumn evalColorX";
    } else {
      return " SmRColumn noEval";
    }

  }

  OpenFavourite(): void {
    let dialogRef = this._dialog.open(FavouriteDialogDigitalFormComponent, {
        disableClose: true,
        data: { }
    });
    dialogRef.afterClosed().subscribe(r => {
        this.loadFavourites();
        if (!r) return;
    });
}

loadFavourites() {
  this._favouriteDialogService.GetDigitalFormFavourites().subscribe(result => {
      if (result != null) {
          this.userFavorites = result;
         this.userFavoritesDefault= this.userFavorites.find(f=>f.isDefaultFav==true)
         console.log("userFavoritesDefault", this.userFavoritesDefault)
         this.showFavorite(this.userFavoritesDefault)
      }
  });
}

UpdateFavourite(favourite) {
  let dialogRef = this._dialog.open(FavouriteDialogDigitalFormComponent, {
      disableClose: true,
      data: {
          favouriteId: favourite.Id
      }
  });
  dialogRef.afterClosed().subscribe(r => {
    this.loadFavourites();
      if (r.data != null) {

      } else {

      }
  });
}

deleteFavorite(favourite){
  if(favourite.Id>0){
      this._favouriteDialogService.RemoveFavouriteDigitalSearch(favourite.Id).subscribe(res=>{
          if(res){
              
              this._notify.success("Deleted successfully");
              this.loadFavourites();
          }else{
              console.log("failed")
          }
      })
  }
  
}

showFavorite(favourite) {
 
    this._favouriteDialogService.LoadFavouriteDetails_DigitalForms(favourite.Id).subscribe(r => {
    //  this.favouriteDetail = r;
      if (this.selectedCategory.length === 0) {
        this.selectedCategory = r.FormCategories;
      }
      this.selectedCategories = this.formCatList.filter(x => this.selectedCategory.includes(x.Id));

      if(this.selectedCategory.length>0){
        this.LoadForms();
      }
      this.selectedCustomer = r.Customers;
      if(this.selectedCustomer.length>0){
        this.loadJobsitesForCustomer();
      }
     
     // this.TypeID = r.DefaultView;
      this.selectedFamily = r.Families;

      if(this.selectedFamily.length>0){
        this.loadModelList();
      }
      //this.favName = r.FavouriteName;    
      
     
      this.selectedForms=r.FormNames;
      this.selectedInspectors=r.Inspectors;
     this.selectedStatus=r.Status; 
     this.selectedJobsite = r.Jobsites;
     this.selectedModel = r.Models;


     if(this.selectedJobsite.length>0){
       this.loadEquipmentForJobsite();
     }
     this.selectedEquipment=r.Machines;
     this.selectedDateRange=r.dateRange_;
     this.submitSelection();
      
    })

  
  
}

numberofNotifications:number
showText:boolean=false
getUserAlertsforDashbpard(){
  this._favouriteDialogService.getCurrentUserAlertsforDigitalForms(DashBoardModule.DFI).subscribe(res=>{
      console.log(res)
   
     this.numberofNotifications=res.filter(x=>x.status==1).length
    
     if( this.numberofNotifications==0){
      this.showText=false;     
     }else{
         this.showText=true;
     }     
  })
}
showAlertDialog(){
  const dialogRef = this._dialog.open(DigitalFormUserAlertComponent, {
    data: { 
      ModuleId: DashBoardModule.DFI
    }
  });
  dialogRef.afterClosed().subscribe(res => {
  this.getUserAlertsforDashbpard();
  });         
}

isAllSelected() {
  const numSelected = this.selection.selected.length;
  const numRows = this.dataSource.length;
  return numSelected === numRows;
}

masterToggle() {
  this.isAllSelected() ?
      this.selection.clear() :
      this.dataSource.forEach(row => this.selection.select(row));
}

selectRows() {
  let endIndex: number;
  if (this.dataSource.length > (this.dataSource.paginator.pageIndex + 1) * this.dataSource.paginator.pageSize) {
    endIndex = (this.dataSource.paginator.pageIndex + 1) * this.dataSource.paginator.pageSize;
  } else {
    endIndex = this.dataSource.length;
  }
  for (let index = (this.dataSource.paginator.pageIndex * this.dataSource.paginator.pageSize); index < endIndex; index++) {
    this.selection.select(this.dataSource[index]);
  }
}

OpenCheckboxDeleteInspection(){
  let UploadIds = this.selection.selected.map(s => s.UploadId);
  const addSectionDialog = this._dialog.open(DeleteConfirmCheckboxDialogComponent, {
  disableClose:true
  });
  addSectionDialog.afterClosed().subscribe(res => {
    if (res == true) {
      this.BulkDeleteDigitalFormInspection(UploadIds);
    }
  });
}

BulkDeleteDigitalFormInspection(UploadIds:any[]){
  var params: BulkDeleteUploadForm = {
    UploadIds: UploadIds
  }
  this._favouriteDialogService.BulkDeleteFormUploadDigitalForm(params).subscribe(res=>{
    if(res==true){
      this._notify.success('Successfully Deleted')
    }else{
      this._notify.error("Error, Please Contact TrackTreads")
    }
 
  })
}

sortData(sort: Sort){
  this.sortedData = this.PerformResult.CompletedForms.slice();
  const data = this.PerformResult.CompletedForms.slice();
    if (!sort.active || sort.direction === '') {
      this.sortedData = data;
      return;
    }

    //this.sortedData = data.sort((a, b) => {
      this.dataSource.data = data.sort((a, b) => {
      const isAsc = sort.direction === 'asc';
      switch (sort.active) {
        //    this.displayedColumns = ['FormId','FormName', 'CatName', 'EqCustomer', 'EQJobsite', 'Serial',
        // 'Unit', 'Model', '', 'SMR' , 'Inspector', '', 'flag','delete', 'description'];

        case 'FormId': return compare(a.FormId, b.FormId, isAsc);
        case 'FormName': return compare(a.FormName, b.FormName, isAsc);
        case 'CatName': return compare(a.CatName, b.CatName, isAsc);
        case 'EqCustomer': return compare(a.EqCustomer, b.EqCustomer, isAsc);
        case 'EQJobsite': return compare(a.EQJobsite, b.EQJobsite, isAsc);
        case 'Serial': return compare(a.Serialno, b.Serialno, isAsc);
        case 'Unit': return compare(a.UnitNo, b.UnitNo, isAsc);
        case 'Model': return compare(a.Model, b.Model, isAsc);
        case 'CreateDate_': return compare(a.CreateDate_, b.CreateDate_, isAsc);
        case 'Status': return compare(a.Status, b.Status, isAsc);
        case 'SMR': return compare(a.SMR, b.SMR, isAsc);
        case 'Inspector': return compare(a.Inspector, b.Inspector, isAsc);
        case 'flag': return compare(a.ImmediateActionCount, b.ImmediateActionCount, isAsc);
        default: return 0;
      }
    });
  }

  selectStatus(statusId:number, event: any){
     if (!this.selectedStatus) { this.selectedStatus = []; }
    if (event.checked) {
      // add if not already present
      if (this.selectedStatus.indexOf(statusId) === -1) {
        this.selectedStatus.push(statusId);
      }
    } else {
      // remove if present
      this.selectedStatus = this.selectedStatus.filter(v => v !== statusId);
    }
    console.log("selectedStatus", this.selectedStatus)
  }


  ChangeCustomeDateType(){

    switch(this.selectedDateRange)
    {
      case 1:
        {
          this.startDate = new Date(new Date().setDate(new Date().getDate() - 2));
          break;
        }
        case 2:
        {
          this.startDate = new Date(new Date().setDate(new Date().getDate() - 7));
          break;
        }
        case 3:
        {
          this.startDate = new Date(new Date().setDate(new Date().getDate() - 30));
          break;
        }
        case 4:
        {
          this.startDate = new Date(new Date().setDate(new Date().getDate() - 90));
          break;
        }
        case 5:
        {
          this.startDate = new Date(new Date().setMonth(new Date().getMonth() - 6));
          break;
        }
        case 6:
        {
          this.startDate = new Date(new Date().setFullYear(new Date().getFullYear() - 1));
          break;
        }
        case 7:
        {
          this.startDate = new Date(new Date().setFullYear(new Date().getFullYear() - 2));
          break;
        }
        case 8:
        {
          this.startDate = new Date(new Date().setFullYear(new Date().getFullYear() - 5));
          break;
        }
        case 9:
        {
          this.startDate = new Date(new Date().setDate(new Date().getDate() - 1));
          break;
        }
        case 10:
        {
          this.startDate = new Date(new Date().setDate(new Date().getDate() - 2));
          break;
        }
        case 11:
        {
          this.startDate = new Date(new Date().setDate(new Date().getDate() - 7));
          break;
        }
        case 12:
        {
          this.startDate = new Date(new Date().setDate(new Date().getDate() - 14));
          break;
        }
        case 13:
        {
          this.startDate = new Date(new Date().setMonth(new Date().getMonth() - 1));
          break;
        }
        case 14:
        {
          this.startDate = new Date(new Date().setFullYear(new Date().getFullYear() - 1));
          break;
        }
        case 15:
        {
          this.startDate = new Date(new Date().setDate(new Date().getDate() - 0));
          break;
        }
        case 16:
        {
          this.startDate = new Date(new Date().setDate(new Date().getDate() - 7));
          break;
        }
        case 17:
          {
            this.startDate = new Date(new Date().setDate(new Date().getDate() - 30));
            break;
          }
          case 18:
          {
            this.startDate = new Date(new Date().setDate(new Date().getFullYear() - 30));
            break;
          }
    
        default:
          this.startDate = this.defaultSearchStartDate;
            this.endDate=this.defaultSearchEndDate
        break;
    }

  }

  openLink(formId,uploadId ){ 


    this._formService.DFIRportAddRecordsNewInspection(uploadId).subscribe(res=>{
      if(res==true){
        window.open('digitalform/reports/'+ formId+ '/'+ uploadId,'_blank');
      }
          
    })

  }

  GetPdfDigitalForm(uploadId:number)
  {
      console.log("report works")

      this._formService.DFIRportAddRecordsNewInspection(uploadId).subscribe(res=>{
        if(res==true){
          //window.open(this.appUris.UCUri + 'api/DigitalFormIdentity/GetPdFDFIReports?FormUploadID=' + uploadId, '_blank');
          window.open(this._appService.getBaseURL() + 'api/DigitalFormIdentity/GetPdFDFIReports?FormUploadID=' + uploadId, '_blank');
        }
            
      })   
    
  }
}

// function compare(a: number | string | Date, b: number | string | Date, isAsc: boolean) {
//   return (a < b ? -1 : 1) * (isAsc ? 1 : -1);
// }
function compare(a, b, isAsc) {
  return (a < b ? -1 : 1) * (isAsc ? 1 : -1);
}


